//© all rights reserved to 6over6 Ltd. 2022. This software (the "Software") is
the property of 6over6 Ltd. and its licensors. Any use of the Software is
strictly prohibited unless an explicit license or permission is granted by
6over6 Ltd.
<template>
  <div
    class="go_unsupported"
    :style="{
      background: store.state.Style.backgroundColor,
    }"
  >
    <component :is="pageIconComponent" />
    <h2 class="go_title" v-html="page.title"></h2>
    <div v-if="page.message" v-html="page.message"></div>
    <div class="go_container-btn">
      <btn
        v-if="page.button"
        :actions="page.button.buttonActions"
        :event="page.button.mixpanelEvent"
        >{{ page.button.buttonTitle }}</btn
      >
    </div>
  </div>
</template>

<script setup>
import AnalyticsEvent from "@/../../../common/models/AnalyticsEvent.js";
import { defineProps, computed, onMounted, inject } from "vue";
import { useStore } from "vuex";
import btn from "@/components/elements/BtnElm.vue";
import Laptop from "@/components/icons/LaptopIcon.vue";
import PhoneOutline from "@/components/icons/PhoneOutlineIcon";
import ZoomInOut from "@/components/icons/ZoomInOutIcon";

const store = useStore();
const props = defineProps(["pageInfo"]);
const api = inject("api");

const page = computed(function () {
  if (props.pageInfo) {
    return props.pageInfo;
  }
  return store.state.page;
});

const pageIconComponent = computed(function () {
  const components = {
    Laptop,
    PhoneOutline,
    ZoomInOut,
  };
  return components[page.value.icon.value];
});

onMounted(function () {
  api.analytics.log(
    new AnalyticsEvent(
      page.value.mixpanelEvent.title,
      page.value.mixpanelEvent.eventType,
      page.value.mixpanelEvent.category
    )
  );
});
</script>

<style lang="scss" scoped>
.go_unsupported {
  z-index: 10;
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  .go_title {
    margin-top: 20px;
  }

  .go_container-btn {
    margin-top: 20px;
  }
}
</style>
